import { render, staticRenderFns } from "./dropdown-list.vue?vue&type=template&id=f4244f84"
import script from "./dropdown-list.vue?vue&type=script&lang=js"
export * from "./dropdown-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports